export default {
  Company: "Company",
  AddCompany: "AddCompany",
  editCompany: "EditCompany"
};
